"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_delivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f503fe7c-e5af-4c19-98b0-7e85c6453170",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 104"
  }, props), /*#__PURE__*/React.createElement("title", null, "delivery"), /*#__PURE__*/React.createElement("g", {
    id: "3afc5cc8-5f20-43fb-b73e-7ef0f71ab35c",
    "data-name": "Delivery_ic+"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.22,43.88",
    transform: "translate(-16 -40)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,124V56a12,12,0,0,0-12-12H32A12,12,0,0,0,20,56v56a12,12,0,0,0,12,12h4.48v0A13,13,0,0,0,36,127.5,12.26,12.26,0,0,0,48,140a12.26,12.26,0,0,0,12-12.5,13.64,13.64,0,0,0-.49-3.5h64.62l0,0a13,13,0,0,0-.47,3.48,12,12,0,1,0,24,0,23.77,23.77,0,0,0-.45-3.42l0-.08H160a12,12,0,0,0,12-12V88L162,60H116",
    transform: "translate(-16 -40)",
    strokeLinejoin: "round"
  })));
}

var _default = ic_delivery;
exports.default = _default;